module.exports = __webpack_public_path__ + "media/images/landing/second_2x/photo25-c4c9c08f4b17b925d8e3ffdc4223997a.jpg";